import React, { useEffect, useRef, useState } from "react";
import { Form } from "react-router-dom";
import axios from "../../API/axios";
import toast from "react-hot-toast";
import { userAuthImage } from "../../config/imagesLink";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { useTranslation } from "react-i18next";

const CCVAttachement = ({
  showCCVAttachement,
  handleCloseCCVAttachement,
  getUserCcv,
  resumeId,
}) => {
  const sessionId = localStorage.getItem("sessionId");
  const [attachement, setAttachement] = useState("");
  const [profilePic, setProfilePic] = useState(null);
  const [display, setDisplay] = useState(false);
  const { t } = useTranslation();

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [isloading, setIsloading] = useState(false);
  const language = localStorage.getItem("Lang");


  // console.log('profilePic', profilePic);
  const [selectedImage, setSelectedImage] = useState(null);
  const fileInputRef = useRef(null);

  const handleImageChange = (event) => {
    const selectedFile = event.target.files[0];
    setProfilePic(selectedFile);
    // setProfilePic(event.target.files[0].name);
    setSelectedImage(event.target.files[0].name);
  };
  //   const handleImageChange = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     setSelectedImage(file.name);
  //     setProfilePic(file);
  //     setDisplay(false); // hide error if previously shown
  //   }
  // };
  const handleClick = () => {
    fileInputRef.current.click();
  };

  const AddAttachement = async () => {
    
    if (!profilePic) {
         setWarningToastMessage("please select a file");
          setShowWarningToast(true);
    }else{
    setIsloading(true);
    setDisplay(true);
      try {
        const formData = new FormData();
        formData.append("DeviceType", "Web");
        formData.append("sessionId", sessionId);
        formData.append("RsmId", resumeId);
        formData.append("AttachmentFile", profilePic);
        formData.append("langKey", language === "en" ? "" : language,);
        const res = await axios.post("ResumeAction/AddAttachment", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true)
        getUserCcv();
        handleCloseCCVAttachement();
        setIsloading(false);
  
      } catch (error) {
        console.log(error);
        if (error.response && error.response.status === 404) {
          setWarningToastMessage(error.response.data.message);
          setShowWarningToast(true);
          setIsloading(false);
  
        } else {
          setErrorToastMessage(error.response.data.responseData );
          setShowErrorToast(true);
          setIsloading(false);
  
        }
      }
    }
  };

  // const handleClick = () => {
  //   fileInputRef.current.click();
  // };



  // const AddAttachement = async () => {
  //   setDisplay(true);
  //   if (!profilePic) return;

  //   const formData = new FormData();
  //   formData.append("DeviceType", "Web");
  //   formData.append("sessionId", sessionId);
  //   formData.append("RsmId", resumeId);
  //   formData.append("AttachmentFile", profilePic);

  //   try {
  //     const res = await axios.post("ResumeAction/AddAttachment", formData, {
  //       headers: { "Content-Type": "multipart/form-data" },
  //     });
  //     setToastMessage(res.data.message);
  //     setShowToast(true);
  //     getUserCcv();
  //     handleCloseCCVAttachement();
  //   } catch (error) {
  //     console.error(error);
  //     const msg = error.response?.data?.message || "Something went wrong";
  //     if (error.response?.status === 404) {
  //       setWarningToastMessage(msg);
  //       setShowWarningToast(true);
  //     } else {
  //       setErrorToastMessage(msg);
  //       setShowErrorToast(true);
  //     }
  //   }
  // };


  // useEffect(() => {
  //   if (showCCVAttachement) {
  //     document.body.style.overflow = 'hidden';
  //     document.documentElement.style.overflow = 'hidden';
  //     document.body.classList.add('modal-open'); // When a modal opens
  //   } else {
  //     document.body.style.overflow = 'unset';
  //     document.documentElement.style.overflow = '';
  //     document.body.classList.remove('modal-open'); // When a modal closes
  //   }
  // }, [showCCVAttachement]);
  return (
    <>
      {showCCVAttachement && (
        <div
          className="modal fade show"
          tabIndex="-1"
          attachement="dialog"
          style={{ display: "block" }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            attachement="document"
          >
            <div className="modal-content">
              <div className="setting-header d-flex justify-content-between align-items-center">
                <h6>{t("User Profile.Add Attachement")}</h6>
                <CloseSharpIcon
                  className="material-symbols-sharp me-2 pointer"
                  onClick={handleCloseCCVAttachement}
                />
              </div>
              {/* <Form>
                <div className="row p-4 settings CreateCompany">
                  <div className="col-md-12 mt-2">
                    <div className="d-flex">
                      <div> 
                        <div className="uploadImage-cont">
                          <img
                            src={userAuthImage.dummy}
                            alt="Upload Image"
                            style={{
                              cursor: "pointer",
                              width: "50px",
                            }}
                            onClick={handleClick}
                          />
                          <p>Choose File</p>
                        </div> 
                        <div className="empty-line"></div>
                        <input
                          type="file"
                          ref={fileInputRef}
                          style={{ display: "none" }}
                          onChange={handleImageChange}
                          accept="/*"
                          invalid={display && selectedImage === ""}
                        />
                        {display && !selectedImage ? (
                          <span className="error_msg_lbl">
                            Please Select picture{" "}
                          </span>
                        ) : null}
                      </div>
                    </div>
                    <div className="uploaded-image" style={{ width: "100%" }}>
                      {selectedImage && <p>{selectedImage}</p>} 
                    </div>
                  </div>
                  <div className="text-end mt-4">
                    <button
                      type="button"
                      className="mainBtn1"
                      onClick={AddAttachement}
                      style={{ width: "170px" }}
                    >
                      Add Attachement
                    </button>
                  </div>
                </div>
              </Form> */}
              <Form>
                <div className="row p-4 settings CreateCompany">
                  <div className="col-md-12 mt-2">
                    <div className="">
                      <div className="uploadImage-cont text-center">
                        {/* <img
            src={userAuthImage.dummy}
            alt="Upload"
            onClick={handleClick}
            style={{ cursor: "pointer", width: "60px", height: "60px", objectFit: "cover", borderRadius: "8px" }}
          /> */}
                        <div className="upload-icon mb-3"
                          onClick={handleClick}
                          style={{ cursor: "pointer", objectFit: "cover" }}
                        >
                          <svg
                            fill="currentColor"
                            viewBox="0 0 36 36"
                            xmlns="http://www.w3.org/2000/svg"
                            width="36px"
                            height="36px"
                          >
                            <title>{t("User Profile.image-line")}</title>
                            <path d="M32,4H4A2,2,0,0,0,2,6V30a2,2,0,0,0,2,2H32a2,2,0,0,0,2-2V6A2,2,0,0,0,32,4ZM4,30V6H32V30Z" />
                            <path d="M8.92,14a3,3,0,1,0-3-3A3,3,0,0,0,8.92,14Zm0-4.6A1.6,1.6,0,1,1,7.33,11,1.6,1.6,0,0,1,8.92,9.41Z" />
                            <path d="M22.78,15.37l-5.4,5.4-4-4a1,1,0,0,0-1.41,0L5.92,22.9v2.83l6.79-6.79L16,22.18l-3.75,3.75H15l8.45-8.45L30,24V21.18l-5.81-5.81A1,1,0,0,0,22.78,15.37Z" />
                          </svg>
                          <p className="mt-2 mb-0 fw-medium">{t("modals.Choose File")}</p>
                        </div>
                      </div>

                      <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleImageChange}
                        style={{ display: "none" }}
                        accept="application/pdf,image/*"
                      />

                      <div className="flex-grow-1">
                        {selectedImage ? (
                          <p className="mb-0">{selectedImage}</p>
                        ) : display ? (
                          <span className="text-danger small">{t("User Profile.Please select a file")}</span>
                        ) : null}
                      </div>
                    </div>
                  </div>

                  <div className="text-end mt-4">
                    <button
                      type="button"
                      className="mainBtn1"
                      onClick={AddAttachement}
                      style={{ width: "180px" }}
                      disabled={isloading}

                    >
                      {isloading === true ? `${t("User Profile.Attachement")}` : `${t("User Profile.Add Attachement")}`}
                    </button>
                  </div>
                </div>
              </Form>

            </div>
          </div>
        </div>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />

    </>
  );
};

export default CCVAttachement;
